/**
 * client/main.ts — single entry for the JustLeave vanilla-TS bundle.
 *
 * Detects `data-mount` markers and activates only what the current page
 * uses. Each island gets one querySelectorAll loop.
 */

import { mountCategoryFilter } from "./category-filter";
import { mountDonationTiers } from "./donation";
import { mountExitCardPing } from "./exit-card";
import { mountFeedback } from "./feedback";
import { mountGuideVote } from "./guide-vote";
import { mountLiveTicker } from "./live-ticker";
import { mountRecentGuidePush, mountRecentGuides } from "./recent-guides";
import { mountReport } from "./report";
import { mountRequestForm } from "./request-form";
import { mountSearch } from "./search";
import { mountStepPreview } from "./step-preview";

for (const el of document.querySelectorAll<HTMLElement>('[data-mount="exit-card"]')) {
  mountExitCardPing(el);
}

for (const el of document.querySelectorAll<HTMLElement>('[data-mount="guide-vote"]')) {
  mountGuideVote(el);
}

for (const el of document.querySelectorAll<HTMLElement>('[data-mount="feedback"]')) {
  mountFeedback(el);
}

for (const el of document.querySelectorAll<HTMLElement>('[data-mount="report"]')) {
  mountReport(el);
}

for (const el of document.querySelectorAll<HTMLInputElement>('input[data-mount="search"]')) {
  mountSearch(el);
}

for (const el of document.querySelectorAll<HTMLElement>('[data-mount="step-preview"]')) {
  mountStepPreview(el);
}

for (const el of document.querySelectorAll<HTMLElement>('[data-mount="category-filter"]')) {
  mountCategoryFilter(el);
}

for (const el of document.querySelectorAll<HTMLFormElement>('form[data-mount="request-form"]')) {
  mountRequestForm(el);
}

for (const el of document.querySelectorAll<HTMLElement>('[data-mount="live-ticker"]')) {
  mountLiveTicker(el);
}

for (const el of document.querySelectorAll<HTMLElement>('[data-mount="recent-guide-push"]')) {
  mountRecentGuidePush(el);
}

for (const el of document.querySelectorAll<HTMLElement>('[data-mount="recent-guides"]')) {
  mountRecentGuides(el);
}

for (const el of document.querySelectorAll<HTMLElement>('[data-mount="donation-tiers"]')) {
  mountDonationTiers(el);
}
